import React, { Fragment, useContext } from "react";
import {
    FiLogOut,
    FiChevronRight,
    FiAlertTriangle,
    FiKey,
    FiMapPin,
    FiAlertOctagon,
} from 'react-icons/fi';
import { IoMdCar } from 'react-icons/io';
import { useTheme, useMediaQuery } from "@mui/material";

import { Booking, VehicleStatus } from "../../../../logic/api";

import styles from "./styles";
import flex from "../../../../styles/flex";

import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";

import { SessionContext } from "../../../../utility/useSession";
import { formatVehicle } from "../../../../utility/utils";
import { useDate } from "../../../../utility/useDate";
import { useTranslation } from "react-i18next";

const KeyLocationListItem: React.FunctionComponent<{
    booking: Booking;
    warning?: string;
    onClick?: () => void
}> = (props) => {
    const session = useContext(SessionContext);
    const theme = useTheme();
    const isLargeDevice = useMediaQuery(theme.breakpoints.up('md'));
    const { t } = useTranslation();
    const { toFormattedDateString, toFormattedDateTimeString, toFormattedTimeString } = useDate();

    const border = styles.bookingListItemBorder(props.booking.vehicle.statusId);

    function getVehicleStatusKey(statusId: VehicleStatus) {
        switch (statusId) {
            case VehicleStatus.NotCheckedIn:
                return 'booking.vehicleStatus.notCheckedIn';
            case VehicleStatus.PreCheckIn:
                return 'booking.vehicleStatus.preCheckIn';
            case VehicleStatus.CheckedIn:
                return 'booking.vehicleStatus.checkedIn';
            case VehicleStatus.CheckedOut:
                return 'booking.vehicleStatus.checkedOut';
            default:
                return 'booking.vehicleStatus.unknown';
        }
    }

    const statusKey = getVehicleStatusKey(props.booking.vehicle.statusId);
    const translatedStatus = t(statusKey)

    if (session.current.site == null) {
        return <Fragment></Fragment>
    }

    return <div data-testid={`key-location-item-${props.booking.id}`} style={{ ...styles.bookingListItem, ...border, paddingBottom: props.warning != null ? 0 : 20 }} onClick={() => {
        if (props.onClick != null) {
            props.onClick();
        }
    }}>
        <div style={{ position: "absolute", textAlign: "center", width: 120, left: -67, bottom: 0, height: 15, top: 30, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", color: "white", transform: "rotate(270deg)" }}>
            <span>{translatedStatus}</span>
        </div>
        <div style={styles.bookingListItemFlex}>
            {(props.booking.vehicleKey.location != null) && (
                <ListViewItemCard
                    icon={props.booking.vehicleKey.missing == true ?
                        <FiAlertOctagon
                            color={"red"}
                            title={t("lists.keyMissing", { date: toFormattedDateTimeString(props.booking.vehicleKey.missingDate ?? undefined) })}
                            style={styles.icon}>
                        </FiAlertOctagon>
                        : <FiKey style={styles.icon} />}
                    text={`${props.booking.vehicleKey.location.parentName} / ${props.booking.vehicleKey.location.name}`}

                    subText={t("locations.row", { row: props.booking.vehicleKey.row == null ? "-" : props.booking.vehicleKey.row })}
                />
            )}
            {(props.booking.vehicleKey.location == null) && (
                <ListViewItemCard
                    icon={<FiKey style={styles.icon} />}
                    text={t("mobile.noLocation")}
                    subText={""}
                />
            )}

            {(props.booking.vehicle.location != null) && (
                <ListViewItemCard
                    icon={props.booking.vehicle.missing == true ?
                        <FiAlertOctagon
                            color={"red"}
                            title={t("lists.vehicleMissing", { date: toFormattedDateTimeString(new Date(props.booking.vehicle.missingDate)) })}
                            style={styles.icon}>
                        </FiAlertOctagon>
                        : <FiMapPin style={styles.icon} />}
                    text={`${props.booking.vehicle.location.parentName} / ${props.booking.vehicle.location.name}`}

                    subText={`Row ${props.booking.vehicle.row == null ? "-" : props.booking.vehicle.row}`}
                />
            )}
            {(props.booking.vehicle.location == null) && (
                <ListViewItemCard
                    icon={<FiMapPin style={styles.icon} />}
                    text={t("mobile.noLocation")}
                    subText={""}
                />
            )}


            <ListViewItemCard
                icon={<IoMdCar style={styles.icon} />}
                text={props.booking.vehicle.registration}
                subText={formatVehicle(props.booking.vehicle)}
            />



            {(isLargeDevice == true || (props.booking.vehicle.statusId == VehicleStatus.CheckedIn)) && (
                <ListViewItemCard
                    icon={<FiLogOut style={styles.icon} />}
                    text={toFormattedDateString(new Date(props.booking.expectedReturnDate))}
                    subText={toFormattedTimeString(new Date(props.booking.expectedReturnDate))}
                />
            )}

            <div style={flex.flexAuto}>
                <div style={{ ...flex.flexRows, alignItems: "center", height: "100%" }}>
                    <div style={flex.flexAuto}>
                        <FiChevronRight style={styles.iconChevron} />
                    </div>
                </div>
            </div>
        </div>
        {props.warning != null && (
            <div style={{ color: "red", textAlign: "right", padding: 5 }}><FiAlertTriangle></FiAlertTriangle> <b>{props.warning}</b></div>
        )}
    </div>
}

export default KeyLocationListItem;